import Form from 'react-bootstrap/Form';
import { Typography } from 'app/components/ui';
import { i18n } from 'app/utils/i18n';
import { useUpdateTag } from 'app/api/tag-queries';
import { isEscapedConceptType } from 'app/utils/tag-utils/getConceptNarrowType';

interface EscapeSwitchProps {
  tagId: string;
  documentSuperId: number;
  currentEscapeValue: boolean | null | undefined;
  conceptType: { typeQname?: string | null; baseXbrliType?: string | null } | null | undefined;
  disabled?: boolean;
}

export const EscapeSwitch = ({ tagId, documentSuperId, currentEscapeValue, conceptType, disabled = false }: EscapeSwitchProps) => {
  const { mutate: updateTag } = useUpdateTag();

  const conceptDefault = isEscapedConceptType(conceptType);
  const checked = currentEscapeValue ?? conceptDefault;
  const diverges = checked !== conceptDefault;

  const handleUpdate = (escape: boolean) => {
    updateTag({ id: tagId, documentSuperId, escape });
  };

  return (
    <>
      <div className="property-row">
        <Typography fontWeight="semibold" className="property-label">
          {i18n('tag.concept.escape.label')}
        </Typography>
        <Form.Check
          type="switch"
          id={`escape-switch-${tagId}`}
          checked={checked}
          onChange={(e) => handleUpdate(e.target.checked)}
          disabled={disabled}
          style={disabled ? { cursor: 'not-allowed' } : undefined}
        />
      </div>
      {diverges && (
        <Typography variant="body-1" fontWeight="light" color="#717077" className="escape-divergence-hint">
          {i18n('tag.concept.escape.diverges')}
        </Typography>
      )}
    </>
  );
};
